import { HTMLProps, forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = createStyles({
  root: {},
});

export interface SidebarSectionContentProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const SidebarSectionContentMui = forwardRef<
  HTMLDivElement,
  SidebarSectionContentProps
>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <div ref={ref} className={classNames(className, classes.root)} {...rest}>
      {children}
    </div>
  );
});

SidebarSectionContentMui.displayName = 'SidebarSectionMui.Content';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore SidebarSection and delete. */
export default withStyles(styles)(SidebarSectionContentMui);
